import { render, staticRenderFns } from "./_rightData.vue?vue&type=template&id=268468a2&scoped=true&"
import script from "./_rightData.vue?vue&type=script&lang=js&"
export * from "./_rightData.vue?vue&type=script&lang=js&"
import style0 from "./_rightData.vue?vue&type=style&index=0&id=268468a2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268468a2",
  null
  
)

export default component.exports